import React, { useEffect } from "react";

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto"; // Cleanup on component unmount
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-96">
        <h2 className="text-lg font-semibold text-gray-800">
          Confirm Delete
        </h2>
        <p className="text-gray-600 mt-2">
          Are you sure you want to delete this time report? This action cannot
          be undone.
        </p>
        <div className="flex justify-end space-x-4 mt-6">
          <button
            className="px-4 py-2 border rounded bg-gray-100 text-gray-700 hover:bg-gray-200"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 border border-red-500 text-red-500 rounded bg-white hover:bg-red-100"
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;